import React from 'react';
import RichContentEditor from './RichContentEditor';

const DEFAULT_MARKDOWN_PLACEHOLDER = `# Guide title

Use markdown here.

| Topic | Detail |
| --- | --- |
| Example | Table row |

- Lists
- **Bold text**
- \`inline code\`

![Image alt](https://example.com/guide-image.jpg)`;

const GuideContentEditor = ({
  htmlValue,
  onChange,
  onImageUpload,
  disabled = false,
  height = 320,
}) => {
  return (
    <RichContentEditor
      htmlValue={htmlValue}
      onChange={onChange}
      onImageUpload={onImageUpload}
      disabled={disabled}
      height={height}
      richTextPlaceholder="Write the public guide here..."
      htmlSourcePlaceholder="<p>Write the public guide HTML here...</p>"
      markdownPlaceholder={DEFAULT_MARKDOWN_PLACEHOLDER}
      conversionNote="Switch between Rich Text, raw HTML, Markdown, and Preview. The saved guide body stays HTML, so Markdown and Rich Text both flow into the published article markup."
      htmlHint="Use raw HTML here when you need markup that the rich-text editor cannot safely preserve, such as custom tables or embed-friendly layouts."
      tableProtectionHint="This article currently contains a table. Rich Text mode is temporarily disabled because it can strip table markup. Keep editing the table in HTML or Markdown until you're done."
      markdownHint="Use fenced code blocks, headings, lists, blockquotes, links, images, and GitHub-style tables here. The saved guide body is still converted into HTML automatically."
      previewHint="This is the rendered guide preview of the saved HTML."
      previewEmptyState="Nothing to preview yet. Start writing in Rich Text, HTML, or Markdown and the rendered article will appear here."
      markdownImageHint="Uploads to the Guides media library and inserts standard markdown image syntax at the cursor."
    />
  );
};

export default GuideContentEditor;
